import { render, staticRenderFns } from "./AddDict.vue?vue&type=template&id=fb3e8c6a&scoped=true"
import script from "./AddDict.vue?vue&type=script&lang=js"
export * from "./AddDict.vue?vue&type=script&lang=js"
import style0 from "./AddDict.vue?vue&type=style&index=0&id=fb3e8c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3e8c6a",
  null
  
)

export default component.exports